<template>
  <div class="animated fadeIn" v-if="pageLoaded">
    <div v-if="loaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-0"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card style="border: 0" class="mt-0 mb-0">
        <b-card
          v-if="
            (status == 'نیاز به تکمیل / اصلاح' || status == 'پیش نویس') &&
            adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ adminMessage }}</b-card
        >
        <b-tabs pills fill vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <b-button
              :disabled="isSaving"
              class="mx-1"
              variant="success"
              @click="saveDraft()"
              >ثبت پیشنویس</b-button
            >
            <b-button
              v-if="tabIndex != 9"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>

          <b-tab :title="`کلیات طرح (${step1progress}%)`">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">کلیات طرح</h4>
              </template>
              <b-form-group>
                <div class="d-flex" dir="ltr">
                  <label
                    for="switch_1"
                    :class="
                      initialObligation
                        ? 'ml-3 mb-0 done'
                        : 'ml-3 mb-0 required'
                    "
                  >
                    اینجانب تعهد می کنم با مطالعه و آگاهی از
                    <b-button
                      id="downLoad"
                      title="دانلود RFP"
                      variant="link"
                      href="https://api.biodcportal.com/setad/public/RFP%20%D9%81%D8%B1%D8%A7%D8%AE%D9%88%D8%A7%D9%86%20%D9%81%D9%86%D8%A7%D9%88%D8%B1%DB%8C.pdf"
                    >
                      <b-tooltip
                        placement="bottomleft"
                        target="downLoad"
                        triggers="hover"
                        variant="info"
                        >دانلود RFP</b-tooltip
                      >ارائه شده RFP</b-button
                    >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست طرح
                    کلان در سامانه اقدام می نمایم
                  </label>
                  <b-form-checkbox
                    id="switch_1"
                    v-model="initialObligation"
                  ></b-form-checkbox>
                </div>
              </b-form-group>
              <hr />
              <h3 class="text-primary mb-4">دانشگاه گرامی</h3>

              <p>
                به ابزار ثبت طرح‌های کلان پژوهشی سامانه تقسیم کار ملی خوش آمدید.
                خواهشمندیم به منظور آغاز فرآیند ثبت طرح کلان اطلاعات زیر را
                تکمیل نمایید:
              </p>
              <b-form-group
                label="عنوان فارسی طرح کلان"
                :class="faSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="faSubject"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="عنوان انگلیسی طرح کلان"
                :class="enSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="موضوع طرح کلان"
                :class="catId ? 'done' : 'required'"
              >
                <Select2
                  class="myselect2"
                  v-model="catId"
                  :options="cats"
                ></Select2>
              </b-form-group>

              <b-form-group
                label="حوزه طرح کلان"
                :class="
                  zoneMedicine || zoneAgriculture || zoneEnvironmentIndustrial
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox class="mt-3 c-dark" v-model="zoneMedicine"
                  >سلامت</b-form-checkbox
                >
                <b-form-checkbox class="mt-3 c-dark" v-model="zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="zoneEnvironmentIndustrial"
                  >محیط زیست و صنعت</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="`مشخصات مجری و راهبر طرح کلان (${step2progress}%)`">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">مشخصات مجری و راهبر طرح کلان</h4>
              </template>
              <h5 class="text-primary mb-4">مشخصات ریاست دانشگاه</h5>
              <b-form-group
                label="نام رئیس دانشگاه"
                :class="assistantName ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="assistantName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="نام خانوادگی رئیس دانشگاه"
                :class="assistantLastName ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="assistantLastName"
                ></b-form-input>
              </b-form-group>
              <!-- <b-row class="border mb-2 pt-2 my-1" align-v="center">
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: شماره موبایل باید مطابق با کد ملی رئیس دانشگاه باشد.
                </p>
              </b-row> -->
              <!-- <b-form-group
                label="کد ملی رییس دانشگاه"
                :class="isIdClass(assistantNatcode) ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="assistantNatcode"
                  aria-describedby="input-1-live-feedback"
                  :state="isID(assistantNatcode)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >کد ملی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label="شماره تلفن همراه رییس دانشگاه"
                :class="assistantMobile ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  dir="ltr"
                  type="number"
                  v-model="assistantMobile"
                ></b-form-input>
              </b-form-group> -->
              <hr />
              <h5 class="text-primary mb-4">مشخصات راهبر طرح کلان</h5>
              <b-form-group
                label="نام راهبر کلان"
                :class="managerName ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="managerName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="نام خانوادگی راهبر کلان"
                :class="managerLastName ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="managerLastName"
                ></b-form-input>
              </b-form-group>
              <b-row class="border mb-2 pt-2 my-1" align-v="center">
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: شماره موبایل باید مطابق با کد ملی راهبر کلان باشد.
                </p>
              </b-row>
              <b-form-group
                label="کد ملی راهبر کلان"
                :class="isIdClass(managerNatcode) ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="managerNatcode"
                  aria-describedby="input-1-live-feedback"
                  :state="isID(managerNatcode)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >کد ملی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label="شماره تلفن همراه راهبر کلان"
                :class="managerMobile ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  dir="ltr"
                  type="number"
                  v-model="managerMobile"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="آدرس ایمیل راهبر کلان"
                :class="isEmailClass(managerEmail) ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  :state="isEmail(managerEmail)"
                  aria-describedby="input-1-live-feedback"
                  type="text"
                  dir="ltr"
                  v-model="managerEmail"
                  @keydown="emailKeydown($event)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >پست الکترونیکی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label="تلفن منزل راهبر کلان"
                :class="managerTel ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  dir="ltr"
                  type="number"
                  v-model="managerTel"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="نشانی منزل راهبر کلان"
                :class="managerAddress ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="managerAddress"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="استان محل اقامت راهبر کلان"
                :class="managerStateId ? 'done' : 'required'"
              >
                <v-autocomplete
                  v-model="managerStateId"
                  :items="iran"
                  @change="managerCityId = ''"
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                label="شهر محل اقامت راهبر کلان"
                :class="managerCityId ? 'done' : 'required'"
              >
                <v-autocomplete
                  v-model="managerCityId"
                  :items="
                    iran
                      .filter((x) => x.id == managerStateId)
                      .map((y) => y.cities)[0]
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                label="شماره تماس محل کار راهبر کلان"
                :class="managerJobTel ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  dir="ltr"
                  type="number"
                  v-model="managerJobTel"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="نشانی محل کار راهبر کلان"
                :class="managerJobAddress ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="managerJobAddress"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="استان محل کار راهبر کلان"
                :class="managerJobStateId ? 'done' : 'required'"
              >
                <v-autocomplete
                  v-model="managerJobStateId"
                  :items="iran"
                  @change="managerJobCityId = ''"
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                label="شهر محل کار راهبر کلان"
                :class="managerJobCityId ? 'done' : 'required'"
              >
                <v-autocomplete
                  v-model="managerJobCityId"
                  :items="
                    iran
                      .filter((x) => x.id == managerJobStateId)
                      .map((y) => y.cities)[0]
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                label="آخرین مدرک تحصیلی راهبر کلان"
                :class="managerLastDegree ? 'done' : 'required'"
              >
                <b-form-select
                  v-model="managerLastDegree"
                  :options="degreeOptions"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="چکیده سوابق علمی، تخصصی و تحقیقاتی  راهبر کلان (200 تا 500 کلمه)"
                :class="
                  managerAbstract
                    ? managerAbstract.split(' ').length < 200 ||
                      managerAbstract.split(' ').length > 500
                      ? 'required'
                      : 'done'
                    : 'required'
                "
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="managerAbstract"
                  max-rows="6"
                ></b-form-textarea>
                طول چکیده:
                {{
                  managerAbstract
                    ? (chek = managerAbstract.split(" ").length)
                    : 0
                }}
                کلمه
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab
            :title="`اطلاعات تکمیلی مرتبط با اجرای طرح(${step3progress}%)`"
          >
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات تکمیلی مرتبط با اجرای طرح</h4>
              </template>
              <h5 class="text-primary mb-4">
                معرفی سایر اعضای هیئت علمی مرتبط
              </h5>
              <b-button
                @click="addScienceCommitteeField()"
                variant="success"
                class="mb-3"
                >افزودن</b-button
              >

              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="scienceCommittee"
                :fields="scienceCommitteeField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delScienceCommitteeField(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(degree)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.degree"
                      :options="degreeOptions"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(position)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.position"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(field)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.field"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(university)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.university"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(year)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.year"
                      type="number"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              <hr />
              <h5 class="text-primary mb-4">سوابق مرتبط با موضوع طرح</h5>
              <b-button
                @click="addRelatedHistoriesField()"
                variant="success"
                class="mb-3"
                >افزودن</b-button
              >

              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="relatedHistories"
                :fields="relatedHistoriesField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delRelatedHistoriesField(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(title)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.title"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(boss)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.boss"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(year)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.year"
                      type="number"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(verification)="data">
                  <div>
                    <b-form-checkbox
                      class="mt-1 c-dark"
                      v-model="data.item.verification"
                      >تاییده دارد</b-form-checkbox
                    >
                  </div>
                </template>
              </b-table>
            </b-card></b-tab
          >
          <b-tab :title="`سطح‌بندی طرح (${step4progress}%)`">
            <b-card>
              <template v-slot:header>
                <h4 class="mb-0">سطح‌بندی طرح</h4>
              </template>
              <h5 class="text-primary mb-4">مشخصات طرح کلان (مگاپروژه)</h5>
              <b-form-group
                label="خلاصه مدیریتی"
                :class="managementAbstract ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  placeholder="شامل اهداف کلان طرح (SMART Objectives)، ضرورت اجرای طرح در جهت دستیابی به اهداف فناورانه، رفع شکاف گلوگاهی زنجیره ارزش فناوری، آثار اقتصادی/ صنعتی/ درمانی و..."
                  rows="6"
                  v-model="managementAbstract"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="خروجی‌های طرح کلان (مگا پروژه)"
                :class="megaOutputsProgress ? 'done' : 'required'"
              >
                <p>
                  عنوان دستاوردهای عینی، خروجی‌ها و فرآیندهای ملموس و
                  قابل‌اندازه‌گیری حاصل از اجرای طرح:
                </p>
                <b-button
                  @click="addMegaOutputsField()"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="megaOutputs"
                  :fields="megaOutputsField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMegaOutputsField(data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
                {{
                  "*در تکمیل این جدول دقت شود. توجه شود که مبنای همکاری‌های آینده ستاد آن است که کلیه تعهدات مربوط به قراردادهای مجری (شامل دستاوردها و خروجی‌های ذکرشده در جدول فوق) در انتهای زمان‌بندی طرح، انجام شوند."
                }}
              </b-form-group>
              <hr />
              <h5 class="text-primary mb-4">مشخصات سطح میانی (بلوک‌ها)</h5>
              <h6 class="mb-4">
                سطح میانی شامل بلوک‌هایی از پروژه است که در تحقق اهداف کلان طرح
                نقش دارند. هر طرح کلان می‌تواند 3 یا 4 طرح میانی داشته باشد.
              </h6>
              <b-form-group
                label="چکیده طرح"
                :class="abstract ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="abstract"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="`ساختار شکست کار (${step5progress}%)`">
            <b-card>
              <template v-slot:header>
                <h4 class="mb-0">ساختار شکست کار (WBS)</h4>
              </template>
              <p>
                در راستای تحقق اهداف کلان هر طرح، ارائه ساختار شکست کار (Work
                Breakdown Structure) برای طرح‌های پیشنهادی سطح میانی (بلوک‌ها)
                الزامی است. توجه فرمایید که شما تا سقف 80 میلیارد ریال می‌توانید
                درخواست بودجه نمایید.
              </p>

              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 1"
                :class="minorData1Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData1)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData1"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField(minorData1, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 2"
                :class="minorData2Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData2)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData2"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField(minorData2, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 3"
                :class="minorData3Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData3)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData3"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData3, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 4"
                :class="minorData4Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData4)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData4"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData4, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 5"
                :class="minorData5Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData5)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData5"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData5, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 6"
                :class="minorData6Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData6)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData6"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData6, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 7"
                :class="minorData7Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData7)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData7"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData7, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group>
              <hr />
              <b-form-group
                label="جدول اطلاعات طرح سطح میانی (بلوک) 8"
                :class="minorData8Progress ? 'done' : 'required'"
              >
                <b-button
                  @click="addMinorDataField(minorData8)"
                  variant="success"
                  class="mb-4"
                  >افزودن</b-button
                >

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData8"
                  :fields="minorDataField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delMinorDataField34(minorData8, data.index)"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(results)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.results"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.quantity"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(time)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.time"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.budget"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-form-group> </b-card
          ></b-tab>
          <b-tab :title="`زمان‌بندی (${step6progress}%)`">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">زمان‌بندی و فازبندی طرح کلان (مگا پروژه)</h4>
              </template>

              <b-card class="flex-grow-1 shadow-sm border-0 p-3">
                <b-row>
                  <b-col md="4" class="text-center border-right">
                    <div class="text-muted small mb-1">زمان آغاز</div>
                    <div class="font-weight-bold text-primary">
                      {{ startDate || "—" }}
                    </div>
                  </b-col>

                  <b-col md="4" class="text-center border-right">
                    <div class="text-muted small mb-1">زمان پایان</div>
                    <div class="font-weight-bold text-primary">
                      {{ finalDate || "—" }}
                    </div>
                  </b-col>

                  <b-col md="4" class="text-center">
                    <div class="text-muted small mb-1">مدت زمان اجرا</div>
                    <div class="font-weight-bold text-primary">
                      {{ duration ? duration + " روز" : "—" }}
                    </div>
                  </b-col>
                </b-row>
              </b-card>

              <b-form-group>
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent >= 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                        @change="changedStartDate(data.item, data.index)"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>
                <p
                  class="mt-3"
                  :class="
                    gantData
                      .map((x) => x.percent)
                      .reduce((a, b) => Number(a) + Number(b), 0) == 100
                      ? 'done'
                      : 'required'
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    gantData.length == 0
                      ? 0
                      : gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }}
                  %
                </p>
                <hr />
                <h5 class="text-primary">گانت چارت مربوطه:</h5>

                <sarmadGantt :items="gantData" :fields="serviceFields" />
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="`هزینه‌ها (${step7progress}%)`">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌ها و مدیریت مالی</h4>
              </template>

              <b-form-group>
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addExpenseField()"
                  >+</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="expenses"
                  :fields="expensesFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delExpenses(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(title)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.title"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(step)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.step"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(expense)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.expense"
                        type="number"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
                جمع کل هزینه‌ها:
                {{
                  expenses.length == 0
                    ? 0
                    : expenses
                        .map((x) => parseInt(x.expense))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                ريال
                <hr />
                <h5 :class="budget ? 'done' : 'required'">
                  بودجه درخواستی (ریال):
                </h5>
                <b-form-input
                  trim
                  dir="ltr"
                  type="number"
                  v-model="budget"
                  @input="limitBudget"
                ></b-form-input>
                <small class="text-muted">حداکثر: ۸۰٬۰۰۰٬۰۰۰٬۰۰۰ ریال</small>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="`تعهدات (${step8progress}%)`">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <b-form-group>
                <b-form-checkbox
                  :class="promiseArrays[0] ? 'done' : 'required'"
                  v-model="promiseArrays[0]"
                >
                  اينجانب
                  {{ `"${assistantName} ${assistantLastName}" ` }}
                  رئیس دانشگاه
                  {{ `"${universityName}" ` }}
                  بدينوسيله مراتب فوق را تأييد می‌نمایم.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="promiseArrays[1] ? 'done' : 'required'"
                  v-model="promiseArrays[1]"
                >
                  اينجانب
                  {{ `"${managerName} ${managerLastName}" ` }}
                  راهبر طرح کلان دانشگاه
                  {{ `"${universityName}" ` }}
                  بدينوسيله مراتب فوق را تأييد می‌نمایم.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="promiseArrays[2] ? 'done' : 'required'"
                  v-model="promiseArrays[2]"
                  >تكميل اين پروپوزال دليل بر تصويب طرح
                  نمی‌باشد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="promiseArrays[3] ? 'done' : 'required'"
                  v-model="promiseArrays[3]"
                  >مجری پروژه صحت مندرجات اين پروپوزال را تأييد مي
                  نمايد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال طرح(' + lastStepProgress + '%)'">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    کلیات طرح&nbsp;({{ step1progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>

              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="faSubject ? 'done' : 'required'">
                        <b>عنوان طرح کلان به زبان فارسی:</b> {{ faSubject }}
                      </li>
                      <li :class="enSubject ? 'done' : 'required'">
                        <b>عنوان طرح کلان به زبان انگلیسی:</b> {{ enSubject }}
                      </li>
                      <li :class="catId ? 'done' : 'required'">
                        <b>موضوع طرح کلان:</b>
                        {{
                          catId ? cats.filter((x) => x.id == catId)[0].text : ""
                        }}
                      </li>

                      <li
                        :class="
                          zoneMedicine ||
                          zoneAgriculture ||
                          zoneEnvironmentIndustrial
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه طرح کلان:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="zoneMedicine"
                            >سلامت</b-form-checkbox
                          >
                          <b-form-checkbox v-model="zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="zoneEnvironmentIndustrial"
                            >محیط زیست و صنعت</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    مشخصات مجری و راهبر طرح کلان&nbsp;({{ step2progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5 class="text-primary mb-4">
                      مشخصات مسئول پژوهشی دانشگاه
                    </h5>
                    <ul>
                      <li :class="assistantName ? 'done' : 'required'">
                        <b>نام رئیس دانشگاه:</b>
                        {{ assistantName }}
                      </li>
                      <li :class="assistantLastName ? 'done' : 'required'">
                        <b>نام خانوادگی رئیس دانشگاه:</b>
                        {{ assistantLastName }}
                      </li>
                      <!-- <li :class="assistantNatcode ? 'done' : 'required'">
                        <b>کد ملی رییس دانشگاه:</b>
                        {{ assistantNatcode }}
                      </li>
                      <li :class="assistantMobile ? 'done' : 'required'">
                        <b>شماره تلفن همراه رئیس دانشگاه:</b>
                        {{ assistantMobile }}
                      </li> -->
                    </ul>
                    <hr />
                    <h5 class="text-primary mb-4">مشخصات راهبر طرح کلان</h5>

                    <ul>
                      <li :class="managerName ? 'done' : 'required'">
                        <b>نام راهبر کلان:</b> {{ managerName }}
                      </li>
                      <li :class="managerLastName ? 'done' : 'required'">
                        <b>نام خانوادگی راهبر کلان:</b> {{ managerLastName }}
                      </li>
                      <li :class="managerNatcode ? 'done' : 'required'">
                        <b>کد ملی راهبر کلان:</b> {{ managerNatcode }}
                      </li>
                      <li :class="managerMobile ? 'done' : 'required'">
                        <b>شماره تلفن همراه راهبر کلان:</b> {{ managerMobile }}
                      </li>
                      <li :class="managerEmail ? 'done' : 'required'">
                        <b>آدرس ایمیل راهبر کلان:</b> {{ managerEmail }}
                      </li>
                      <li :class="managerTel ? 'done' : 'required'">
                        <b>تلفن منزل راهبر کلان:</b> {{ managerTel }}
                      </li>
                      <li :class="managerAddress ? 'done' : 'required'">
                        <b>نشانی منزل راهبر کلان:</b> {{ managerAddress }}
                      </li>
                      <li :class="managerStateId ? 'done' : 'required'">
                        <b>استان محل اقامت راهبر کلان:</b>
                        {{ managerStateName ? managerStateName : "-" }}
                      </li>
                      <li :class="managerCityId ? 'done' : 'required'">
                        <b>شهر محل اقامت راهبر کلان:</b>
                        {{ managerCityName ? managerCityName : "-" }}
                      </li>
                      <li :class="managerJobTel ? 'done' : 'required'">
                        <b>شماره تماس محل کار راهبر کلان:</b>
                        {{ managerJobTel }}
                      </li>
                      <li :class="managerJobAddress ? 'done' : 'required'">
                        <b>نشانی محل کاربر راهبر کلان:</b>
                        {{ managerJobAddress }}
                      </li>
                      <li :class="managerJobStateId ? 'done' : 'required'">
                        <b>استان محل کار راهبر کلان:</b>
                        {{ managerJobStateName ? managerJobStateName : "-" }}
                      </li>
                      <li :class="managerJobCityId ? 'done' : 'required'">
                        <b>شهر محل کار راهبر کلان:</b>
                        {{ managerJobCityName ? managerJobCityName : "-" }}
                      </li>
                      <li :class="managerLastDegree ? 'done' : 'required'">
                        <b>آخرین مدرک تحصیلی راهبر کلان:</b>
                        {{ managerLastDegree }}
                      </li>
                      <li :class="managerAbstract ? 'done' : 'required'">
                        <b>چکیده سوابق علمی، تخصصی و تحقیقاتی راهبر کلان:</b>
                        {{ managerAbstract }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اطلاعات تکمیلی مرتبط با اجرای طرح&nbsp;({{
                      step3progress
                    }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5 class="text-primary mb-4">
                      معرفی سایر اعضای هیئت علمی مرتبط
                    </h5>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="scienceCommittee"
                      :fields="scienceCommitteeField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>

                    <hr />
                    <h5 class="text-primary mb-4">سوابق مرتبط با موضوع طرح</h5>

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="relatedHistories"
                      :fields="relatedHistoriesField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    سطح‌بندی طرح&nbsp;({{ step4progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        class="mb-4"
                        :class="managementAbstract ? 'done' : 'required'"
                      >
                        <b>خلاصه مدیریتی:</b> {{ managementAbstract }}
                      </li>
                      <li
                        class="mb-4"
                        :class="megaOutputsProgress ? 'done' : 'required'"
                      >
                        <b> خروجی‌های طرح کلان (مگا پروژه):</b>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="megaOutputs"
                          :fields="megaOutputsField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary my-3"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </li>
                      <li class="mb-4" :class="abstract ? 'done' : 'required'">
                        <b>چکیده طرح:</b> {{ abstract }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    ساختار شکست کار (WBS)&nbsp;({{ step5progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <h4
                      class="mb-6"
                      :class="minorData1Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 1:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData1"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr />
                    <h4
                      class="mb-6"
                      :class="minorData2Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 2:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData2"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData3.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData3.length"
                      :class="minorData3Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 3:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData3"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData3.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData4.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData4.length"
                      :class="minorData4Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 4:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData4"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData4.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData5.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData5.length"
                      :class="minorData5Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 5:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData5"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData5.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData6.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData6.length"
                      :class="minorData6Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 6:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData6"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData6.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData7.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData7.length"
                      :class="minorData7Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 7:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData7"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData7.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <hr v-if="minorData8.length" />
                    <h4
                      class="mb-6"
                      v-if="minorData8.length"
                      :class="minorData8Progress ? 'done' : 'required'"
                    >
                      جدول اطلاعات طرح سطح میانی (بلوک) 8:
                    </h4>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="minorData8"
                      :fields="minorDataField"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                      v-if="minorData8.length"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    زمانبندی طرح&nbsp;({{ step6progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  زمان‌بندی و فازبندی طرح کلان (مگا پروژه)
                  <b-card-text class="shadow p-3">
                    <b-card class="flex-grow-1 shadow-sm border-0 p-3">
                      <b-row>
                        <b-col md="4" class="text-center border-right">
                          <div class="text-muted small mb-1">زمان آغاز</div>
                          <div class="font-weight-bold text-primary">
                            {{ startDate || "—" }}
                          </div>
                        </b-col>

                        <b-col md="4" class="text-center border-right">
                          <div class="text-muted small mb-1">زمان پایان</div>
                          <div class="font-weight-bold text-primary">
                            {{ finalDate || "—" }}
                          </div>
                        </b-col>

                        <b-col md="4" class="text-center">
                          <div class="text-muted small mb-1">مدت زمان اجرا</div>
                          <div class="font-weight-bold text-primary">
                            {{ duration ? duration + " روز" : "—" }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>

                    <div>
                      <sarmadGantt
                        v-if="show"
                        :items="gantData"
                        :fields="serviceFields"
                      />
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    هزینه‌ها&nbsp;({{ step7progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 7"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h4 class="mb-0">هزینه‌ها و مدیریت مالی</h4>

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="expenses"
                      :fields="expensesFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary mb-4"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <p>
                      جمع کل هزینه‌ها:
                      {{
                        expenses.length == 0
                          ? 0
                          : expenses
                              .map((x) => parseInt(x.expense))
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      ريال
                    </p>
                    <hr />
                    <h3>
                      بودجه درخواستی:
                      {{ budget.toLocaleString() }}
                      ریال
                    </h3>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-11 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;({{ step8progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 10"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-11"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox v-model="promiseArrays[0]">
                        <b :class="promiseArrays[0] ? 'done' : 'required'">
                          اينجانب
                          {{ `"${assistantName} ${assistantLastName}" ` }}
                          رئیس دانشگاه
                          {{ `"${universityName}" ` }}
                          بدينوسيله مراتب فوق را تأييد می‌نمایم.</b
                        >
                      </b-form-checkbox>
                      <b-form-checkbox v-model="promiseArrays[1]">
                        <b :class="promiseArrays[1] ? 'done' : 'required'">
                          اينجانب
                          {{ `"${managerName} ${managerLastName}" ` }}
                          راهبر طرح کلان دانشگاه
                          {{ `"${universityName}" ` }}
                          بدينوسيله مراتب فوق را تأييد می‌نمایم.
                        </b>
                      </b-form-checkbox>
                      <b-form-checkbox v-model="promiseArrays[2]"
                        ><b :class="promiseArrays[2] ? 'done' : 'required'">
                          تكميل اين پروپوزال دليل بر تصويب طرح نمی‌باشد.
                        </b></b-form-checkbox
                      >
                      <b-form-checkbox v-model="promiseArrays[3]"
                        ><b :class="promiseArrays[3] ? 'done' : 'required'"
                          >مجری پروژه صحت مندرجات اين پروپوزال را تأييد مي
                          نمايد.</b
                        ></b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-button
              class="m-2"
              variant="success"
              :disabled="lastStepProgress != 100"
              @click="submitProposal()"
              >ارسال طرح</b-button
            >
            <p v-if="lastStepProgress != 100" class="required">
              به منظور ارسال طرح کلان باید تمام مراحل را به صورت کامل (100%) پشت
              سر گذاشته باشید.
            </p>
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-saveDraft-2) previous -->
          <b-button
            :disabled="isSaving"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 8"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";

export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      reactivity: false,
      reactivity2: false,
      isSaving: false,
      selectedReviewer: {},
      color: "",
      tabIndex: 0,
      isLoaded: true,
      showTop: false,
      loaded: false,
      pageLoaded: false,
      iran: [],
      //----------------- Uni Request------------------//
      universityName: "",
      status: "",
      adminMessage: "",
      initialObligation: false,
      faSubject: "",
      enSubject: "",
      catId: "",
      cats: [],
      zoneMedicine: false,
      zoneAgriculture: false,
      zoneEnvironmentIndustrial: false,
      assistantName: "",
      assistantLastName: "",
      // assistantMobile: "",
      // assistantNatcode: "",
      managerName: "",
      managerLastName: "",
      managerMobile: "",
      managerNatcode: "",
      managerEmail: "",
      managerTel: "",
      managerAddress: "",
      managerCityId: "",
      managerStateId: "",
      managerJobCityId: "",
      managerJobStateId: "",
      managerStateName: "",
      managerCityName: "",
      managerJobStateName: "",
      managerJobCityName: "",
      managerJobTel: "",
      managerJobAddress: "",
      managerLastDegree: "",
      degreeOptions: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      managerAbstract: "",
      scienceCommittee: [
        {
          name: "",
          position: "",
          degree: "",
          field: "",
          university: "",
          year: "",
        },
      ],
      scienceCommitteeField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "position", label: "سمت" },
        { key: "degree", label: "آخرین مدرک تحصیلی" },
        { key: "field", label: "رشته تحصیلی" },
        { key: "university", label: "نام موسسه محل تحصیل" },
        { key: "year", label: "سال دریافت" },
        { key: "operation", label: "" },
      ],
      relatedHistories: [
        {
          title: "",
          boss: "",
          year: "",
          verification: false,
        },
      ],
      relatedHistoriesField: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان طرح" },
        { key: "boss", label: "کارفرما" },
        { key: "year", label: "سال اجرا" },
        { key: "verification", label: "وجود تاییدیه کارفرما" },
        { key: "operation", label: "" },
      ],

      managementAbstract: "",
      abstract: "",
      megaOutputs: [
        {
          title: "",
          quantity: "",
          time: "",
        },
      ],
      megaOutputsField: [
        { key: "index", label: "#" },
        { key: "title", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
        { key: "operation", label: "" },
      ],
      minorDataField: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "results", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
        { key: "budget", label: "بودجه پیشنهادی (میلیون ریال)" },
        { key: "operation", label: "" },
      ],
      minorData1: [
        {
          title: "",
          results: "",
          quantity: "",
          time: "",
          budget: "",
        },
      ],
      minorData2: [
        {
          title: "",
          results: "",
          quantity: "",
          time: "",
          budget: "",
        },
      ],
      minorData3: [],
      minorData4: [],
      minorData5: [],
      minorData6: [],
      minorData7: [],
      minorData8: [],
      gantData: [],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      budget: 0,
      expenses: [
        {
          title: "",
          step: "",
          expense: 0,
        },
      ],
      expensesFields: [
        { key: "index", label: "#" },
        { key: "title", label: "نوع هزینه" },
        { key: "step", label: "سطح میانی (بلوک)" },
        { key: "expense", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      promiseArrays: [false, false, false, false],
      revision: 0,
      requestsCode: "",
    };
  },

  methods: {
    getUniRequestInfo() {
      this.$bvModal.show("loading");
      this.isLoaded = false;

      this.$http
        .get(
          `${this.baseUrl}/setad/university/uniRequest/${this.$route.params.id}`,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          const unirequest = res.data;
          this.adminMessage = unirequest.adminMessage
            ? unirequest.adminMessage
            : "";
          this.status = unirequest.status;
          this.universityName = unirequest.universityName;
          this.initialObligation = unirequest.initialObligation
            ? unirequest.initialObligation
            : false;
          this.faSubject = unirequest.faSubject;
          this.enSubject = unirequest.enSubject;
          this.catId = unirequest.catId;
          this.zoneMedicine = unirequest.zoneMedicine
            ? unirequest.zoneMedicine
            : false;
          this.zoneAgriculture = unirequest.zoneAgriculture
            ? unirequest.zoneAgriculture
            : false;
          this.zoneEnvironmentIndustrial = unirequest.zoneEnvironmentIndustrial
            ? unirequest.zoneEnvironmentIndustrial
            : false;
          //--------------------Assistant & Manager-------------------//
          this.assistantName = unirequest.assistantName
            ? unirequest.assistantName
            : "";
          this.assistantLastName = unirequest.assistantLastName
            ? unirequest.assistantLastName
            : "";
          // this.assistantNatcode = unirequest.assistantNatcode
          //   ? unirequest.assistantNatcode
          //   : "";
          // this.assistantMobile = unirequest.assistantMobile
          //   ? unirequest.assistantMobile
          //   : "";
          this.managerName = unirequest.managerName
            ? unirequest.managerName
            : "";
          this.managerLastName = unirequest.managerLastName
            ? unirequest.managerLastName
            : "";
          this.managerNatcode = unirequest.managerNatcode
            ? unirequest.managerNatcode
            : "";
          this.managerMobile = unirequest.managerMobile
            ? unirequest.managerMobile
            : "";
          this.managerEmail = unirequest.managerEmail
            ? unirequest.managerEmail
            : "";
          this.managerTel = unirequest.managerTel ? unirequest.managerTel : "";
          this.managerAddress = unirequest.managerAddress
            ? unirequest.managerAddress
            : "";
          this.managerCityId = unirequest.managerCityId
            ? unirequest.managerCityId
            : "";
          this.managerStateId = unirequest.managerStateId
            ? unirequest.managerStateId
            : "";
          this.managerJobCityId = unirequest.managerJobCityId
            ? unirequest.managerJobCityId
            : "";
          this.managerJobStateId = unirequest.managerJobStateId
            ? unirequest.managerJobStateId
            : "";
          this.managerStateName = unirequest.managerStateName;
          this.managerCityName = unirequest.managerCityName;
          this.managerJobStateName = unirequest.managerJobStateName;
          this.managerJobCityName = unirequest.managerJobCityName;
          this.managerJobTel = unirequest.managerJobTel
            ? unirequest.managerJobTel
            : "";
          this.managerJobAddress = unirequest.managerJobAddress
            ? unirequest.managerJobAddress
            : "";
          this.managerLastDegree = unirequest.managerLastDegree
            ? unirequest.managerLastDegree
            : "";
          this.managerAbstract = unirequest.managerAbstract
            ? unirequest.managerAbstract
            : "";
          this.scienceCommittee = unirequest.scienceCommittee
            ? unirequest.scienceCommittee.length
              ? unirequest.scienceCommittee
              : [
                  {
                    name: "",
                    position: "",
                    degree: "",
                    field: "",
                    university: "",
                    year: "",
                  },
                ]
            : [
                {
                  name: "",
                  position: "",
                  degree: "",
                  field: "",
                  university: "",
                  year: "",
                },
              ];
          this.relatedHistories = unirequest.relatedHistories
            ? unirequest.relatedHistories.length
              ? unirequest.relatedHistories
              : [
                  {
                    title: "",
                    boss: "",
                    year: "",
                    verification: false,
                  },
                ]
            : [
                {
                  title: "",
                  boss: "",
                  year: "",
                  verification: false,
                },
              ];
          this.managementAbstract = unirequest.managementAbstract
            ? unirequest.managementAbstract
            : "";
          this.abstract = unirequest.abstract ? unirequest.abstract : "";
          this.megaOutputs = unirequest.megaOutputs
            ? unirequest.megaOutputs.length
              ? unirequest.megaOutputs
              : [
                  {
                    title: "",
                    quantity: "",
                    time: "",
                  },
                ]
            : [
                {
                  title: "",
                  quan: "",
                  time: "",
                },
              ];
          this.minorData1 = unirequest.minorData1
            ? unirequest.minorData1.length
              ? unirequest.minorData1
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ]
            : [
                {
                  title: "",
                  results: "",
                  quantity: "",
                  time: "",
                  budget: "",
                },
              ];
          this.minorData2 = unirequest.minorData2
            ? unirequest.minorData2.length
              ? unirequest.minorData2
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ]
            : [
                {
                  title: "",
                  results: "",
                  quantity: "",
                  time: "",
                  budget: "",
                },
              ];
          this.minorData3 = unirequest.minorData3
            ? unirequest.minorData3.length
              ? unirequest.minorData3
              : []
            : [];
          this.minorData4 = unirequest.minorData4
            ? unirequest.minorData4.length
              ? unirequest.minorData4
              : []
            : [];
          this.minorData5 = unirequest.minorData5
            ? unirequest.minorData5.length
              ? unirequest.minorData5
              : []
            : [];
          this.minorData6 = unirequest.minorData6
            ? unirequest.minorData6.length
              ? unirequest.minorData6
              : []
            : [];
          this.minorData7 = unirequest.minorData7
            ? unirequest.minorData7.length
              ? unirequest.minorData7
              : []
            : [];
          this.minorData8 = unirequest.minorData8
            ? unirequest.minorData8.length
              ? unirequest.minorData8
              : []
            : [];
          this.gantData = unirequest.gantData
            ? unirequest.gantData.length
              ? unirequest.gantData
              : []
            : [];
          // this.duration = unirequest.duration ? unirequest.duration : "";
          // this.startDate = unirequest.startDate ? unirequest.startDate : "";
          // this.finalDate = unirequest.finalDate ? unirequest.finalDate : "";
          this.budget = unirequest.budget ? unirequest.budget : 0;
          this.expenses = unirequest.expenses
            ? unirequest.expenses.length
              ? unirequest.expenses
              : [
                  {
                    title: "",
                    step: "",
                    expense: 0,
                  },
                ]
            : [
                {
                  title: "",
                  step: "",
                  expense: 0,
                },
              ];

          this.promiseArrays = unirequest.promiseArrays
            ? unirequest.promiseArrays
            : [false, false, false, false];
          this.revision = unirequest.revision ? unirequest.revision : 0;
          this.requestsCode = unirequest.requestsCode
            ? unirequest.requestsCode
            : "";
          //---------------------Set page structure---------------------//
          document.body.classList.toggle("sidebar-minimized");
          document.body.classList.toggle("brand-minimized");
          this.toast(
            "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
          );

          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.show = true;
            this.pageLoaded = true;
          }, 200);
          this.loaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    nameKeydown(enSubject) {
      if (/[^a-zA-Z 0-9]/.test(enSubject.key)) {
        enSubject.preventDefault();
      }
    },
    emailKeydown(email) {
      if (/[^a-zA-Z0-9._%+\-@]/.test(email.key)) {
        email.preventDefault();
      }
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.gantData[index].dueDate = this.computedMinDate(data.startDate);
      }
    },
    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    isEmail(email) {
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isEmailClass(email) {
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isID(id) {
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isIdClass(id) {
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////

      // save draft !!!
      this.saveDraft();
      ////////////////
    },
    addScienceCommitteeField() {
      this.scienceCommittee.push({
        name: "",
        position: "",
        degree: "",
        field: "",
        university: "",
        year: "",
      });
      const title = (
        <div>
          <h5>!هیئت علمی جدید افزوده شد</h5>
          <span>لطفا اطلاعات هیئت علمی را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delScienceCommitteeField(order) {
      if (this.scienceCommittee.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک نفر از اعضای هیئت علمی باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.scienceCommittee.splice(order, 1);
      }
    },
    addRelatedHistoriesField() {
      this.relatedHistories.push({
        title: "",
        boss: "",
        year: "",
        verification: false,
      });
      const title = (
        <div>
          <h5>!هیئت تاریخچه افزوده شد</h5>
          <span>لطفا اطلاعات تاریخچه را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delRelatedHistoriesField(order) {
      if (this.relatedHistories.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک تاریخچه باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.relatedHistories.splice(order, 1);
      }
    },
    addMegaOutputsField() {
      this.megaOutputs.push({
        name: "",
        position: "",
        degree: "",
        field: "",
        university: "",
        year: "",
      });
      const title = (
        <div>
          <h5>!خروجی جدید افزوده شد</h5>
          <span>لطفا اطلاعات خروجی را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delMegaOutputsField(order) {
      if (this.megaOutputs.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک خروجی باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.megaOutputs.splice(order, 1);
      }
    },
    addMinorDataField(minorData) {
      minorData.push({
        name: "",
        position: "",
        degree: "",
        field: "",
        university: "",
        year: "",
      });
      const title = (
        <div>
          <h5>!عنوان جدید افزوده شد</h5>
          <span>لطفا اطلاعات را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    delMinorDataField(minorData, order) {
      if (minorData.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک عنوان باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        minorData.splice(order, 1);
      }
    },
    delMinorDataField34(minorData, order) {
      minorData.splice(order, 1);
    },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    delService(order) {
      this.gantData.splice(order, 1);
    },
    addExpenseField() {
      this.expenses.push({
        title: "",
        step: "",
        expense: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>لطفا اطلاعات هزینه را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    delExpenses(order) {
      if (this.expenses.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک هزینه باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.expenses.splice(order, 1);
      }
    },
    submitProposal() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      if (this.revision > 0) {
        this.$http
          .patch(
            `${this.baseUrl}/setad/university/uniRequest/${this.$route.params.id}`,
            {
              faSubject: this.faSubject,
              enSubject: this.enSubject,
              initialObligation: this.initialObligation,
              catId: this.catId,
              zoneMedicine: this.zoneMedicine,
              zoneAgriculture: this.zoneAgriculture,
              zoneEnvironmentIndustrial: this.zoneEnvironmentIndustrial,
              assistantName: this.assistantName,
              assistantLastName: this.assistantLastName,
              // assistantNatcode: this.assistantNatcode,
              // assistantMobile: this.assistantMobile,
              managerName: this.managerName,
              managerLastName: this.managerLastName,
              managerNatcode: this.managerNatcode,
              managerMobile: this.managerMobile,
              managerEmail: this.managerEmail,
              managerTel: this.managerTel,
              managerAddress: this.managerAddress,
              managerCityId: this.managerCityId
                ? this.managerCityId
                : undefined,
              managerStateId: this.managerStateId
                ? this.managerStateId
                : undefined,
              managerJobTel: this.managerJobTel,
              managerJobAddress: this.managerJobAddress,
              managerLastDegree: this.managerLastDegree,
              managerAbstract: this.managerAbstract,
              managerJobCityId: this.managerJobCityId
                ? this.managerJobCityId
                : undefined,
              managerJobStateId: this.managerJobStateId
                ? this.managerJobStateId
                : undefined,
              scienceCommittee: this.scienceCommittee,
              relatedHistories: this.relatedHistories,
              managementAbstract: this.managementAbstract,
              abstract: this.abstract,
              megaOutputs: this.megaOutputs,
              minorData1: this.minorData1,
              minorData2: this.minorData2,
              minorData3: this.minorData3,
              minorData4: this.minorData4,
              minorData5: this.minorData5,
              minorData6: this.minorData6,
              minorData7: this.minorData7,
              minorData8: this.minorData8,
              gantData: this.gantData,
              duration: this.duration,
              startDate: this.startDate,
              finalDate: this.finalDate,
              expenses: this.expenses,
              budget: this.budget,
              promiseArrays: this.promiseArrays,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            router.push("/university/uniRequest/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          });
      } else {
        this.$http
          .patch(
            `${this.baseUrl}/setad/university/uniRequest/submit/${this.$route.params.id}`,
            {
              faSubject: this.faSubject,
              enSubject: this.enSubject,
              initialObligation: this.initialObligation,
              catId: this.catId,
              zoneMedicine: this.zoneMedicine,
              zoneAgriculture: this.zoneAgriculture,
              zoneEnvironmentIndustrial: this.zoneEnvironmentIndustrial,
              assistantName: this.assistantName,
              assistantLastName: this.assistantLastName,
              // assistantNatcode: this.assistantNatcode,
              // assistantMobile: this.assistantMobile,
              managerName: this.managerName,
              managerLastName: this.managerLastName,
              managerNatcode: this.managerNatcode,
              managerMobile: this.managerMobile,
              managerEmail: this.managerEmail,
              managerTel: this.managerTel,
              managerAddress: this.managerAddress,
              managerCityId: this.managerCityId
                ? this.managerCityId
                : undefined,
              managerStateId: this.managerStateId
                ? this.managerStateId
                : undefined,
              managerJobTel: this.managerJobTel,
              managerJobAddress: this.managerJobAddress,
              managerLastDegree: this.managerLastDegree,
              managerAbstract: this.managerAbstract,
              managerJobCityId: this.managerJobCityId
                ? this.managerJobCityId
                : undefined,
              managerJobStateId: this.managerJobStateId
                ? this.managerJobStateId
                : undefined,
              scienceCommittee: this.scienceCommittee,
              relatedHistories: this.relatedHistories,
              managementAbstract: this.managementAbstract,
              abstract: this.abstract,
              megaOutputs: this.megaOutputs,
              minorData1: this.minorData1,
              minorData2: this.minorData2,
              minorData3: this.minorData3,
              minorData4: this.minorData4,
              minorData5: this.minorData5,
              minorData6: this.minorData6,
              minorData7: this.minorData7,
              minorData8: this.minorData8,
              gantData: this.gantData,
              duration: this.duration,
              startDate: this.startDate,
              finalDate: this.finalDate,
              expenses: this.expenses,
              budget: this.budget,
              promiseArrays: this.promiseArrays,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            router.push("/university/uniRequest/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          });
      }
    },
    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;

      this.$http
        .patch(
          `${this.baseUrl}/setad/university/uniRequest/draft/${this.$route.params.id}`,
          {
            faSubject: this.faSubject,
            enSubject: this.enSubject,
            initialObligation: this.initialObligation,
            catId: this.catId,
            zoneMedicine: this.zoneMedicine,
            zoneAgriculture: this.zoneAgriculture,
            zoneEnvironmentIndustrial: this.zoneEnvironmentIndustrial,
            assistantName: this.assistantName,
            assistantLastName: this.assistantLastName,
            // assistantNatcode: this.assistantNatcode,
            // assistantMobile: this.assistantMobile,
            managerName: this.managerName,
            managerLastName: this.managerLastName,
            managerNatcode: this.managerNatcode,
            managerMobile: this.managerMobile,
            managerEmail: this.managerEmail,
            managerTel: this.managerTel,
            managerAddress: this.managerAddress,
            managerCityId: this.managerCityId ? this.managerCityId : undefined,
            managerStateId: this.managerStateId
              ? this.managerStateId
              : undefined,
            managerJobTel: this.managerJobTel,
            managerJobAddress: this.managerJobAddress,
            managerLastDegree: this.managerLastDegree,
            managerAbstract: this.managerAbstract,
            managerJobCityId: this.managerJobCityId
              ? this.managerJobCityId
              : undefined,
            managerJobStateId: this.managerJobStateId
              ? this.managerJobStateId
              : undefined,
            scienceCommittee: this.scienceCommittee,
            relatedHistories: this.relatedHistories,
            managementAbstract: this.managementAbstract,
            abstract: this.abstract,
            megaOutputs: this.megaOutputs,
            minorData1: this.minorData1,
            minorData2: this.minorData2,
            minorData3: this.minorData3,
            minorData4: this.minorData4,
            minorData5: this.minorData5,
            minorData6: this.minorData6,
            minorData7: this.minorData7,
            minorData8: this.minorData8,
            gantData: this.gantData,
            duration: this.duration,
            startDate: this.startDate,
            finalDate: this.finalDate,
            expenses: this.expenses,
            budget: this.budget,
            promiseArrays: this.promiseArrays,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then(() => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getUniCats() {
      this.$http
        .get(this.baseUrl + "/setad/university/uniRequest/cats", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.cats = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    limitBudget() {
      const MAX = 80000000000;
      // If value is greater than max, clamp it
      if (this.budget > MAX) {
        this.budget = MAX;
      }
      // Prevent negative values if needed
      if (this.budget < 0) {
        this.budget = 0;
      }
    },
  },
  computed: {
    step1progress() {
      let progress = 0;
      let total = 5;
      this.initialObligation ? progress++ : 1;
      this.faSubject ? progress++ : 1;
      this.enSubject ? progress++ : 1;
      this.catId ? progress++ : 1;

      this.zoneMedicine ||
      this.zoneAgriculture ||
      this.zoneEnvironmentIndustrial
        ? progress++
        : 1;

      return parseInt((progress / total) * 100);
    },
    step2progress() {
      let progress = 0;
      let total = 17;

      this.assistantName ? progress++ : 0;
      this.assistantLastName ? progress++ : 0;
      // this.assistantNatcode && this.checkCodeMeli(this.assistantNatcode)
      //   ? progress++
      //   : 0;
      // this.assistantMobile ? progress++ : 0;
      this.managerName ? progress++ : 0;
      this.managerLastName ? progress++ : 0;
      this.managerNatcode && this.checkCodeMeli(this.managerNatcode)
        ? progress++
        : 0;
      this.managerMobile ? progress++ : 0;
      this.managerEmail
        ? this.validateEmail(this.managerEmail)
          ? progress++
          : 0
        : 0;
      this.managerTel ? progress++ : 0;
      this.researcherCityId ? progress++ : 0;
      this.managerAddress ? progress++ : 0;
      this.managerCityId ? progress++ : 0;
      this.managerStateId ? progress++ : 0;
      this.managerJobCityId ? progress++ : 0;
      this.managerJobStateId ? progress++ : 0;
      this.managerJobTel ? progress++ : 0;
      this.managerJobAddress ? progress++ : 0;
      this.managerLastDegree ? progress++ : 0;
      this.managerAbstract
        ? this.managerAbstract.split(" ").length >= 200 ||
          this.managerAbstract.split(" ").length <= 500
          ? progress++
          : 0
        : 0;
      return parseInt((progress / total) * 100);
    },
    step3progress() {
      // NOTE (c-step3Progress) previous
      let progress = 0;
      let scienceCommitteeLength = this.scienceCommittee.length;
      let relatedHistoriesLength = this.relatedHistories.length;
      let total =
        Number(scienceCommitteeLength) * 6 + Number(relatedHistoriesLength) * 4;

      this.scienceCommittee.forEach((x) => {
        x.name ? progress++ : 0;
        x.position ? progress++ : 0;
        x.degree ? progress++ : 0;
        x.field ? progress++ : 0;
        x.university ? progress++ : 0;
        x.year ? progress++ : 0;
      });

      this.relatedHistories.forEach((x) => {
        x.title ? progress++ : 0;
        x.boss ? progress++ : 0;
        x.year ? progress++ : 0;
        typeof x.verification === "boolean" ? progress++ : 0;
      });

      return parseInt((progress / total) * 100);
    },
    step4progress() {
      let progress = 0;
      let total = Number(this.megaOutputs.length) * 3 + 2;
      this.managementAbstract ? progress++ : 1;
      this.abstract ? progress++ : 1;

      this.megaOutputs.forEach((x) => {
        x.title ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
      });

      return parseInt((progress / total) * 100);
    },
    step5progress() {
      let progress = 0;
      let total =
        Number(this.minorData1.length) * 5 +
        Number(this.minorData2.length) * 5 +
        Number(this.minorData3.length) * 5 +
        Number(this.minorData4.length) * 5 +
        Number(this.minorData5.length) * 5 +
        Number(this.minorData6.length) * 5 +
        Number(this.minorData7.length) * 5 +
        Number(this.minorData8.length) * 5;

      this.minorData1.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      this.minorData2.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      if (this.minorData3.length)
        this.minorData3.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      if (this.minorData4.length)
        this.minorData4.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      if (this.minorData5.length)
        this.minorData5.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      if (this.minorData6.length)
        this.minorData6.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      if (this.minorData7.length)
        this.minorData7.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      if (this.minorData8.length)
        this.minorData8.forEach((x) => {
          x.title ? progress++ : 0;
          x.results ? progress++ : 0;
          x.quantity ? progress++ : 0;
          x.time ? progress++ : 0;
          x.budget ? progress++ : 0;
        });

      return parseInt((progress / total) * 100);
    },
    step6progress() {
      let progress = 0;
      let total = 1;

      if (this.gantData.length == 0) return 0;

      total += this.gantData.length * 4;

      this.gantData.forEach((x) => {
        x.description ? progress++ : 1;
        x.percent == 0 || x.percent ? progress++ : 1;
        x.startDate ? progress++ : 1;
        x.dueDate ? progress++ : 1;
      });

      this.gantData
        .map((x) => x.percent)
        .reduce((a, b) => Number(a) + Number(b), 0) == 100
        ? progress++
        : 1;

      return parseInt((progress / total) * 100);
    },
    step7progress() {
      let progress = 0;
      let total = 1;
      total += this.expenses.length * 3;

      this.expenses.forEach((x) => {
        x.title ? progress++ : 1;
        x.step ? progress++ : 1;
        x.expense ? progress++ : 1;
      });
      if (this.budget) progress++;

      return parseInt((progress / total) * 100);
    },
    step8progress() {
      let progress = 0;
      for (let i = 0; i <= 3; i++) {
        this.promiseArrays[i] ? progress++ : 1;
      }
      return parseInt((progress / 4) * 100);
    },
    lastStepProgress() {
      let wholeSteps = 0;
      for (let i = 1; i <= 8; i++) {
        wholeSteps += this["step" + i + "progress"];
      }
      // x => (wholeSteps += this["step" + x + "progress"])

      return parseInt(wholeSteps / 8);
    },
    megaOutputsProgress() {
      let progress = 0;
      let total = Number(this.megaOutputs.length) * 3;

      this.megaOutputs.forEach((x) => {
        x.title ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData1Progress() {
      let progress = 0;
      let total = Number(this.minorData1.length) * 5;

      this.minorData1.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData2Progress() {
      let progress = 0;
      let total = Number(this.minorData2.length) * 5;

      this.minorData2.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData3Progress() {
      if (!this.minorData3.length) return true;
      let progress = 0;
      let total = Number(this.minorData3.length) * 5;

      this.minorData3.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData4Progress() {
      if (!this.minorData4.length) return true;
      let progress = 0;
      let total = Number(this.minorData4.length) * 5;

      this.minorData4.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData5Progress() {
      if (!this.minorData5.length) return true;
      let progress = 0;
      let total = Number(this.minorData5.length) * 5;

      this.minorData5.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData6Progress() {
      if (!this.minorData6.length) return true;
      let progress = 0;
      let total = Number(this.minorData6.length) * 5;

      this.minorData6.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData7Progress() {
      if (!this.minorData7.length) return true;
      let progress = 0;
      let total = Number(this.minorData7.length) * 5;

      this.minorData7.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    minorData8Progress() {
      if (!this.minorData8.length) return true;
      let progress = 0;
      let total = Number(this.minorData8.length) * 5;

      this.minorData8.forEach((x) => {
        x.title ? progress++ : 0;
        x.results ? progress++ : 0;
        x.quantity ? progress++ : 0;
        x.time ? progress++ : 0;
        x.budget ? progress++ : 0;
      });

      return progress == total ? true : false;
    },
    startDate() {
      if (!this.gantData.length) return "";
      const min = Math.min(
        ...this.gantData.map((x) =>
          new Date(
            moment(x.startDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          ).getTime()
        )
      );
      return moment(new Date(min)).format("jYYYY/jMM/jDD");
    },
    finalDate() {
      if (!this.gantData.length) return "";
      const max = Math.max(
        ...this.gantData.map((x) =>
          new Date(
            moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          ).getTime()
        )
      );
      return moment(new Date(max)).format("jYYYY/jMM/jDD");
    },
    duration() {
      if (!this.gantData.length) return "";
      const min = Math.min(
        ...this.gantData.map((x) =>
          new Date(
            moment(x.startDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          ).getTime()
        )
      );
      const max = Math.max(
        ...this.gantData.map((x) =>
          new Date(
            moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
          ).getTime()
        )
      );
      return (max - min) / 1000 / 60 / 60 / 24;
    },
  },
  mounted() {
    this.getStatesAndCities();
    this.getUniCats();
    this.tabIndex = 0;
    this.getUniRequestInfo();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove arrows in Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
